import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "memories-top-bar top-bar"
}
const _hoisted_2 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NcActions, { inline: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_NcActionButton, {
                "aria-label": _ctx.t('memories', 'Cancel'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clear()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_CloseIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Cancel')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.n('memories', '{n} selected', '{n} selected', _ctx.size, { n: _ctx.size })), 1),
          _createVNode(_component_NcActions, { inline: 3 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getActions(), (action) => {
                return (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: action.name,
                  "aria-label": action.name,
                  disabled: !!_ctx.loading,
                  "close-after-click": "",
                  onClick: ($event: any) => (_ctx.click(action))
                }, {
                  icon: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), { size: 20 }))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(action.name) + " ", 1)
                  ]),
                  _: 2
                }, 1032, ["aria-label", "disabled", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}